module.exports = __webpack_public_path__ + "img/team7.6edf608a.jpg";